import { Outlet, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

const ROUTE_ACTIVE_TAB = {
  "/dashboard":          "Dashboard",
  "/kyc":                "Kyc",
  "/profile":            "Profile",
  "/wallet":             "Wallet",
  "/myips":              "My Ip's",
  "/services":           "Services",
  "/my-service":         "Service Wise Ledger Report",
  "/activity":           "Activity",
  "/gst-invoices":       "GST Invoice",
  "/complaints":         "Complaints",
  "/fund-request":       "Fund Request",
  "/api-key":            "API Key",
  "/whitelisted-banks":  "Whitelisted Banks",
  "/transactions":       "Transaction",
  "/transaction-details":"Transaction",
  "/onboard":            "Kyc",
};

export default function AppShell() {
  const { pathname } = useLocation();
  const [contentLoading, setContentLoading] = useState(false);
  const activeTab = ROUTE_ACTIVE_TAB[pathname] || "Dashboard";

  // Show spinner briefly on route change — no full page blank
  useEffect(() => {
    setContentLoading(true);
    const t = setTimeout(() => setContentLoading(false), 80);
    return () => clearTimeout(t);
  }, [pathname]);

  return (
    <div className="flex h-screen font-sans overflow-hidden bg-[#F8F9FA]">
      <Sidebar activeTab={activeTab} />
      <div className="flex-1 flex flex-col overflow-hidden ml-[260px]">
        <Navbar />
        <div className="flex-1 overflow-y-auto relative">
          <Outlet />
          {contentLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-[#F8F9FA]/60 pointer-events-none">
              <div className="w-8 h-8 border-[3px] border-[#4B2364] border-t-transparent rounded-full animate-spin" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
